import React, { FC } from 'react';
import styled from 'styled-components';
import { ReactionProps, Reaction } from 'api/conversations';
import { User } from 'api/models';
import { Reactions } from 'components/atoms/reactions';

const ReactionsWrapper = styled(Reactions)`
  align-items: center;
  display: flex;
  margin: var(--spacing-03) 0;
`;

const AddReactionsButton = styled(Reactions.Add)`
  width: var(--height-sm);
  min-width: var(--height-sm);
  height: var(--height-sm);
  &:hover,
  &:focus {
    color: inherit;
    border-color: var(--border-color);
  }
`;

export const UserMessageCommentReactions: FC<{
  currentUser: User;
  parentRef: HTMLDivElement | null;
  reactions: ReactionProps[];
  onChangeReaction(reactionType: Reaction): void;
  onReactionVisibilityChange(state: boolean): void;
}> = ({
  currentUser,
  parentRef,
  reactions,
  onChangeReaction,
  onReactionVisibilityChange,
}) => (
  <ReactionsWrapper>
    <Reactions.Summary
      currentUser={currentUser}
      reactions={reactions}
      onChangeReaction={onChangeReaction}
    />
    {reactions.length < 3 && (
      <AddReactionsButton
        attachTo={parentRef}
        shape="circle"
        onAddReaction={onChangeReaction}
        onReactionVisibilityChange={onReactionVisibilityChange}
      />
    )}
  </ReactionsWrapper>
);
